import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Container, Typography, Grid, Box, Paper } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  section: {
    padding: theme.spacing(10, 0),
    backgroundColor: "#f9f9f9",
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(6, 0),
    },
  },
  title: {
    textAlign: "center",
    marginBottom: theme.spacing(6),
    fontWeight: 700,
    fontSize: "2.5rem",
    color: theme.palette.text.primary,
    [theme.breakpoints.down("sm")]: {
      fontSize: "2rem",
      marginBottom: theme.spacing(4),
    },
  },
  featureCard: {
    padding: theme.spacing(4),
    height: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",
    transition: "all 0.3s ease",
    borderRadius: 12,
    backgroundColor: "#ffffff",
    "&:hover": {
      transform: "translateY(-8px)",
      boxShadow: "0 12px 24px rgba(0,0,0,0.1)",
    },
  },
  icon: {
    fontSize: "4rem",
    marginBottom: theme.spacing(2),
    color: theme.palette.primary.main,
  },
  featureTitle: {
    fontWeight: 600,
    marginBottom: theme.spacing(1.5),
    fontSize: "1.5rem",
    color: theme.palette.text.primary,
  },
  featureDescription: {
    color: theme.palette.text.secondary,
    fontSize: "1rem",
    lineHeight: 1.6,
  },
}));

const FeaturesSection = ({ title, features = [] }) => {
  const classes = useStyles();

  if (!features || features.length === 0) {
    return null;
  }

  return (
    <Box className={classes.section}>
      <Container>
        <Typography variant="h2" className={classes.title}>
          {title}
        </Typography>
        <Grid container spacing={4}>
          {features.map((feature) => (
            <Grid item xs={12} sm={6} md={4} key={feature.id}>
              <Paper className={classes.featureCard} elevation={2}>
                <div className={classes.icon}>{feature.icon}</div>
                <Typography variant="h5" className={classes.featureTitle}>
                  {feature.title}
                </Typography>
                <Typography variant="body1" className={classes.featureDescription}>
                  {feature.description}
                </Typography>
              </Paper>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default FeaturesSection;
